module.exports = __webpack_public_path__ + "img/free-b6.4b40ae17.png";